import { render, staticRenderFns } from "./the-sidebar.vue?vue&type=template&id=31b67c1e&scoped=true&"
import script from "./the-sidebar.vue?vue&type=script&lang=js&"
export * from "./the-sidebar.vue?vue&type=script&lang=js&"
import style0 from "./the-sidebar.vue?vue&type=style&index=0&id=31b67c1e&scoped=true&lang=scss&"
import style1 from "./the-sidebar.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b67c1e",
  null
  
)

export default component.exports